// ----------------------------------------------------------------------

const ROOTS = {
  AUTH: "/auth",
  DASHBOARD: "/dashboard",
  USER: "/users",
  CATEGORY: "/categories",
  PRAYER: "/prayer",
  TAG: "/tags",
  REVIEW: "/reviews",
  CHANGE_PASSWORD: "/change-password",
};

// ----------------------------------------------------------------------

export const paths = {
  // faqs: '/faqs',
  // minimalStore: 'https://mui.com/store/items/minimal-dashboard/',
  // AUTH
  auth: {
    // amplify: {
    //   signIn: `${ROOTS.AUTH}/amplify/sign-in`,
    //   verify: `${ROOTS.AUTH}/amplify/verify`,
    //   signUp: `${ROOTS.AUTH}/amplify/sign-up`,
    //   updatePassword: `${ROOTS.AUTH}/amplify/update-password`,
    //   resetPassword: `${ROOTS.AUTH}/amplify/reset-password`,
    // },
    jwt: {
      signIn: `/login`,
      signUp: `${ROOTS.AUTH}/jwt/sign-up`,
    },
    // firebase: {
    //   signIn: `${ROOTS.AUTH}/firebase/sign-in`,
    //   verify: `${ROOTS.AUTH}/firebase/verify`,
    //   signUp: `${ROOTS.AUTH}/firebase/sign-up`,
    //   resetPassword: `${ROOTS.AUTH}/firebase/reset-password`,
    // },
    // auth0: {
    //   signIn: `${ROOTS.AUTH}/auth0/sign-in`,
    // },
    // supabase: {
    //   signIn: `${ROOTS.AUTH}/supabase/sign-in`,
    //   verify: `${ROOTS.AUTH}/supabase/verify`,
    //   signUp: `${ROOTS.AUTH}/supabase/sign-up`,
    //   updatePassword: `${ROOTS.AUTH}/supabase/update-password`,
    //   resetPassword: `${ROOTS.AUTH}/supabase/reset-password`,
    // },
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    // two: `${ROOTS.DASHBOARD}/user`,
    // three: `${ROOTS.DASHBOARD}/three`,
    // group: {
    //   root: `${ROOTS.DASHBOARD}/group`,
    //   five: `${ROOTS.DASHBOARD}/group/five`,
    //   six: `${ROOTS.DASHBOARD}/group/six`,
    // },
  },
  user: ROOTS.USER,
  category: ROOTS.CATEGORY,
  prayer: ROOTS.PRAYER,
  tag: ROOTS.TAG,
  review: ROOTS.REVIEW,
  changePassword: ROOTS.CHANGE_PASSWORD,
};
